import PathwayNavigationIcon from './component'

export default PathwayNavigationIcon
